<nav class="app-datanavigator text-{{navigationAlign}}">
    <ul class="pagination advanced {{sizeClasses[navigationSize]}}" *ngIf="navigationType === 'Classic'">
        <li class="disabled">
            <a [title]="appLocale.LABEL_FIRST" name="first" href="javascript:void(0);" aria-label="First">
                <span aria-hidden="true"><i class="wi wi-first-page"></i></span>
                <span class="sr-only">{{appLocale.LABEL_FIRST}}</span>
            </a>
        </li>
        <li class="disabled">
            <a [title]="appLocale.LABEL_PREVIOUS" name="prev" href="javascript:void(0);" aria-label="Previous">
                <span aria-hidden="true"><i class="wi wi-chevron-left"></i></span>
                <span class="sr-only">{{appLocale.LABEL_PREVIOUS}}</span>
            </a>
        </li>
        <li class="pagecount disabled">
            <a><input type="number" [attr.aria-label]="'Page Navigation ' + currentPage" class="form-control"
                    value="{{currentPage || dataset?.length ? '1': 0}}" />
            </a>
        </li>
        <li class="disabled">
            <a> / {{pageCount}}</a>
        </li>
        <li class="disabled">
            <a [title]="appLocale.LABEL_NEXT" name="next" href="javascript:void(0);" aria-label="Next">
                <span aria-hidden="true"><i class="wi wi-chevron-right"></i></span>
                <span class="sr-only">{{appLocale.LABEL_NEXT}}</span>
            </a>
        </li>
        <li class="disabled">
            <a [title]="appLocale.LABEL_LAST" name="last" href="javascript:void(0);" aria-label="Last">
                <span aria-hidden="true"><i class="wi wi-last-page"></i></span>
                <span class="sr-only">{{appLocale.LABEL_LAST}}</span>
            </a>
        </li>
        <li *ngIf="showrecordcount" class="totalcount disabled">
            <a>{{appLocale.LABEL_TOTAL_RECORDS}}: {{dataset?.length}}</a>
        </li>
    </ul>
    <ul class="pager {{sizeClasses[navigationSize]}}" *ngIf="navigationType === 'Pager'">
        <li class="previous disabled">
            <a href="javascript:void(0);" aria-label="Previous">
                <span aria-hidden="true"><i class="wi wi-chevron-left"></i></span>
                {{appLocale.LABEL_PREVIOUS}}
                <span class="sr-only">{{appLocale.LABEL_PREVIOUS}}</span>
            </a>
        </li>
        <li class="next disabled">
            <a href="javascript:void(0);" aria-label="Next">
                {{appLocale.LABEL_NEXT}}
                <span aria-hidden="true"><i class="wi wi-chevron-right"></i></span>
                <span class="sr-only">{{appLocale.LABEL_NEXT}}</span>
            </a>
        </li>
    </ul>
    <pagination class="pagination basic" [ngClass]="sizeClasses[navigationSize]" *ngIf="navigationType === 'Basic'"
        [itemsPerPage]="pageCount" [totalItems]="dataset?.length" [ngModel]="currentPage"
        [attr.aria-label]="'Page ' + currentPage + ' of ' + pageCount + ' pages'" [maxSize]="pageCount" previousText="."
        nextText="." firstText="." lastText="."></pagination>
    <ul *ngIf="navigationType === 'Basic' && showrecordcount" class="pagination">
        <li class="totalcount disabled basiccount"><a>{{appLocale.LABEL_TOTAL_RECORDS}}: {{dataset?.length}}</a></li>
    </ul>
</nav>
